import AppBar from '@mui/material/AppBar';
import Link from '@mui/material/Link';
import React from 'react';
import { useTranslation } from 'react-i18next';
function FooterLayout() {
  const { t } = useTranslation('default');
  return (
    <AppBar id="sme-footer" color="primary" position="relative" sx={{ p: 2, pl: 4 }}>
      <div>
        &#169; {new Date().getFullYear()}{' '}
        <Link color="inherit" href="https://coriolisesg.com/" target="_blank" underline="hover">
          TradeSun, Inc.
        </Link>
      </div>
      <div>
        <Link
          color="inherit"
          href="https://pnqa35.p3cdn1.secureserver.net/wp-content/uploads/2023/01/Coriolis-Privacy-Policy.pdf"
          target="_blank"
          underline="hover"
        >
          {t('terms-privacy')}
        </Link>
      </div>
    </AppBar>
  );
}

export default React.memo(FooterLayout);
